import { render } from "./AddSaleComponent.vue?vue&type=template&id=349800c2&scoped=true"
import script from "./AddSaleComponent.vue?vue&type=script&lang=js"
export * from "./AddSaleComponent.vue?vue&type=script&lang=js"

import "./AddSaleComponent.vue?vue&type=style&index=0&id=349800c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349800c2"]])

export default __exports__